import React from 'react';
import cn from '@/utils/cn';
import { IconProps } from './types/IconInterface';

const Dot = ({ className, style }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={cn('text-inherit', className)}
    width="8"
    height="9"
    style={style}
    viewBox="0 0 8 9"
    fill="none">
    <path
      d="M0 4.33331C0 2.12417 1.79086 0.333313 4 0.333313C6.20914 0.333313 8 2.12417 8 4.33331C8 6.54245 6.20914 8.33331 4 8.33331C1.79086 8.33331 0 6.54245 0 4.33331Z"
      fill="currentColor"
    />
  </svg>
);

export default Dot;
